export default "__VITE_ASSET__TSZQ8PJm__"